import getAttachmentTextPreview, {
    GetAttachmentTextPreviewError,
} from 'owa-attachment-text-preview/lib/services/getAttachmentTextPreview';
import { lazySxSDataModule } from 'owa-sxsdata';
import { orchestrator } from 'satcheljs';
import { reloadTextPreview } from '../actions/publicLazyActions';
import getOrCreateSxSStoreData from '../store/Store';
import { lazyGetAttachment } from 'owa-attachment-model-store';
import { getMailboxRequestOptions } from 'owa-request-options-types';

orchestrator(reloadTextPreview, async actionMessage => {
    const { readMode, sxsId } = actionMessage;
    const sxsDataModule = await lazySxSDataModule.import();
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    const getAttachment = await lazyGetAttachment.import();
    const attachmentModel = getAttachment(sxsStore.extendedViewState.attachmentId);
    const allowDownload = attachmentModel?.info?.allowDownload;
    try {
        const textContent = await getAttachmentTextPreview(
            sxsStore.extendedViewState.attachmentId.Id,
            getMailboxRequestOptions(sxsStore.extendedViewState.attachmentId.mailboxInfo),
            readMode
        );
        sxsDataModule.setTextPreviewState(
            sxsStore.viewState,
            textContent,
            allowDownload,
            sxsStore.viewState.previewPane
        );
    } catch (error) {
        const typedError: GetAttachmentTextPreviewError = error;
        if (typedError?.errorMessage) {
            sxsDataModule.setPreviewError(sxsStore.viewState, typedError.errorMessage);
            throw typedError.error;
        }

        throw error;
    }
});
